import { useState, useEffect } from 'react';
import { MessageSquare } from 'lucide-react';
import { useChat } from '../../context/ChatContext';
import { useAuth } from '../../context/AuthContext';
import { ChatPanel } from './ChatPanel';

export function ChatFAB() {
  const { user } = useAuth();
  const { unreadCount } = useChat();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleOpenChat = () => setOpen(true);
    window.addEventListener('open-chat', handleOpenChat);
    return () => window.removeEventListener('open-chat', handleOpenChat);
  }, []);

  // Only visible to supervisor, admin, and operator roles
  const visible = user && ['supervisor', 'admin', 'operator'].includes(user.role);
  if (!visible) return null;

  return (
    <>
      <button
        id="chat-fab"
        className="chat-fab"
        onClick={() => setOpen(o => !o)}
        aria-label="Abrir chat"
        title="Chat con Supervisor / Operador"
      >
        <MessageSquare size={22} />
        {unreadCount > 0 && (
          <span className="chat-fab__badge">{unreadCount > 9 ? '9+' : unreadCount}</span>
        )}
      </button>

      <ChatPanel isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
}
